var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-2" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "9" } }, [
            _vm.link
              ? _c("a", { attrs: { href: _vm.link, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              : _c("span", [_vm._v(_vm._s(_vm.text))])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }